import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import './SchoolTabs.css';

const SchoolTabs = ({ categories }) => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const activeTab = searchParams.get('school') || 'brainsInternacional';

  useEffect(() => {
    // Set default school if none is selected (only on mount)
    if (!searchParams.get('school')) {
      navigate('/shop?school=brainsInternacional', { replace: true });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []); // Only run on mount

  const handleTabClick = (schoolValue) => {
    navigate(`/shop?school=${schoolValue}`);
  };

  return (
    <div className="school-tabs-container container">
      <div className="school-tabs">
        {categories?.map((category) => (
          <button
            key={category.value}
            className={`school-tab ${activeTab === category.value ? 'active' : ''}`}
            onClick={() => handleTabClick(category.value)}
          >
            <span className="school-tab-name">{category.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default SchoolTabs;
